import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Había probado tres marcas de inositol de Amazon, pero mis ciclos seguían siendo de 45 o 60 días. Mi ginecólogo me explicó que la proporción 40:1 de MyoChiro-Pro era la clave técnica que me faltaba. Llevo 3 meses usándolo y, por primera vez en años, mi ciclo es de 28 días exactos. Siento que recuperé el control que los anticonceptivos me habían quitado.',
  name: 'Mariana V.',
  age: '32 años',
  location: 'CDMX',
  highlight: 'mi ciclo es de 28 días exactos'
}, {
  quote: 'Como arquitecta, mi día es intenso y el SOP me causaba una fatiga cerebral terrible y antojos incontrolables de azúcar a las 4 p.m. Desde que integré el protocolo de MyoChiro-Pro, mi energía es constante. Ya no tengo esos picos de glucosa y mi inflamación abdominal bajó notablemente. Es el primer suplemento que realmente siento que trabaja a nivel celular.',
  name: 'Carolina R.',
  age: '38 años',
  location: 'Monterrey',
  highlight: 'mi energía es constante'
}, {
  quote: 'Luché con acné hormonal en la mandíbula por años. Usaba cremas costosas pero el problema era interno. Al entender que el Caronositol® ayuda a regular los andrógenos, decidí darle una oportunidad a MyoChiro-Pro. A las 8 semanas, mi piel se limpió por completo. No es magia, es darle al ovario la proporción exacta que necesita para no producir exceso de grasa.',
  name: 'Jimena L.',
  age: '29 años',
  location: 'Guadalajara',
  highlight: 'mi piel se limpió por completo'
}];
export function TestimonialsSection() {
  return <section id="testimonios" className="py-20 md:py-28 bg-cream relative overflow-hidden" data-id="element-211">
      {/* Subtle decorative accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] bg-pink-brand/5 rounded-full blur-[100px] pointer-events-none" data-id="element-212" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-213">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-214">
          <span className="inline-block text-pink-brand font-semibold text-sm tracking-widest uppercase mb-4" data-id="element-215">
            Historias Reales
          </span>
          <h2 className="text-3xl md:text-5xl font-heading text-dark" data-id="element-216">
            Ellas ya sienten{' '}
            <span className="text-pink-brand" data-id="element-217">la diferencia.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-218">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="relative bg-white rounded-2xl p-8 shadow-lg border border-warm-gray flex flex-col" data-id="element-219">
              {/* Quote icon */}
              <QuoteIcon className="w-8 h-8 text-pink-brand/20 mb-4 flex-shrink-0" data-id="element-220" />

              {/* Testimonial text */}
              <p className="text-gray-600 leading-relaxed flex-grow text-[15px]" data-id="element-221">
                "
                {t.quote.split(t.highlight).map((part, idx, arr) => idx < arr.length - 1 ? <Fragment key={idx} data-id="element-222">
                      {part}
                      <strong className="text-dark font-semibold" data-id="element-223">
                        {t.highlight}
                      </strong>
                    </Fragment> : <Fragment key={idx} data-id="element-224">{part}</Fragment>)}
                "
              </p>

              {/* Attribution */}
              <div className="mt-6 pt-5 border-t border-warm-gray flex items-center gap-3" data-id="element-225">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-brand to-pink-light flex items-center justify-center text-white font-bold text-sm flex-shrink-0" data-id="element-226">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-227">
                  <p className="font-bold text-dark text-sm" data-id="element-228">{t.name}</p>
                  <p className="text-xs text-gray-400" data-id="element-229">
                    {t.age} · {t.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}